/**
 * Serviço de Chat e Consultas à IA
 * Comunicação com a Aline (assistente que ensina a usar o sistema)
 */

import api from './api';

const chatService = {
  /**
   * Pergunta à Aline como usar o sistema
   */
  sendMessage: async (message, conversationHistory = []) => {
    try {
      const response = await api.post('/chat/message', {
        message,
        conversationHistory
      });
      return response;
    } catch (error) {
      console.error('❌ [ChatService] Erro ao enviar mensagem:', error);
      throw error;
    }
  },

  /**
   * Consulta específica sobre dedutibilidade de despesa
   */
  consultarDedutibilidade: async (despesa) => {
    try {
      console.log('🔍 [ChatService] Consultando dedutibilidade:', despesa);
      const response = await api.post('/chat/consultar-dedutibilidade', {
        despesa
      });
      console.log('✅ [ChatService] Análise fiscal recebida');
      return response;
    } catch (error) {
      console.error('❌ [ChatService] Erro ao consultar dedutibilidade:', error);
      throw error;
    }
  },

  /**
   * Marca usuário como não sendo mais primeiro acesso
   */
  markNotFirstAccess: async () => {
    try {
      console.log('✅ [ChatService] Marcando não primeiro acesso');
      const response = await api.post('/chat/mark-not-first-access');
      return response;
    } catch (error) {
      console.error('❌ [ChatService] Erro ao marcar primeiro acesso:', error);
      throw error;
    }
  }
};

export default chatService;
